/**
 * Created by shubham on 10/5/18.
 */

import { NgModule} from '@angular/core';
import { Http} from '@angular/http';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ActivateDeactivateModule } from '../../activate-deactivate-request/activate-deactivate-request.module';
import { ManagerAssignmentRoutingModule } from './managerAssignment-routing.module';
import { ManagerAssignmentComponent } from './managerAssignment.component';
import { ManagerListComponent } from './managerList/managerList.component';
import { AddManagerComponent } from './addManager/addManager.component';
import { ViewManagerComponent } from './viewManager/viewManager.component';
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import {AngularMultiSelectModule} from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { APPCONFIG } from '../../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        NgxDatatableModule,
        AngularMultiSelectModule,
        ReactiveFormsModule,
        ActivateDeactivateModule,
        ManagerAssignmentRoutingModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+'/_ah/api/noAuthApi/v1/i18nJson', ''),
            deps: [Http]
        })
    ],
    declarations: [
        ManagerAssignmentComponent,
        ManagerListComponent,
        AddManagerComponent,
        ViewManagerComponent
    ],
    exports: [
    ]
})

export class ManagerAssignmentModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/managerAssignment/managerAssignment.module.ts